<svg
  [style.opacity]="opacity"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 20 12"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
>
  <defs>
    @if (hasGradient) {
    <linearGradient [attr.id]="gradientId" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" [style.stop-color]="startColor" />
      <stop offset="100%" [style.stop-color]="endColor" />
    </linearGradient>
    }
  </defs>

  <path
    d="M10.1062 0.6625L7.08125 3.1125C6.57813 3.51875 6.48125 4.25 6.8625 4.77187C7.26563 5.32812 8.05 5.4375 8.59062 5.01562L11.6938 2.60313C11.9125 2.43438 12.225 2.47188 12.3969 2.69063C12.5688 2.90938 12.5281 3.22188 12.3094 3.39375L11.6562 3.9L17.1938 9H18.5C19.3281 9 20 8.32812 20 7.5V3.5C20 2.67188 19.3281 2 18.5 2H15.9781L15.8562 1.92188L13.5875 0.46875C13.1094 0.1625 12.55 0 11.9812 0C11.3 0 10.6375 0.234375 10.1062 0.6625ZM10.8188 4.55L9.20312 5.80625C8.21875 6.575 6.79062 6.375 6.05312 5.3625C5.35937 4.40938 5.53437 3.07813 6.45 2.3375L9.05 0.234375C8.6875 0.08125 8.29688 0.00312495 7.9 0.00312495C7.3125 -4.77303e-08 6.74062 0.175 6.25 0.5L4 2H1.5C0.671875 2 0 2.67188 0 3.5V7.5C0 8.32812 0.671875 9 1.5 9H4.88125L7.7375 11.6062C8.35 12.1656 9.29687 12.1219 9.85625 11.5094C10.0281 11.3187 10.1438 11.0969 10.2031 10.8656L10.7344 11.3531C11.3438 11.9125 12.2937 11.8719 12.8531 11.2625C12.9937 11.1094 13.0969 10.9312 13.1625 10.7469C13.7688 11.1531 14.5937 11.0687 15.1031 10.5125C15.6625 9.90312 15.6219 8.95313 15.0125 8.39375L10.8188 4.55Z"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : (color || defaultColor)"
  />
</svg>
